"use client";

import React from "react";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="102627" className="p-4 bg-[#FFF9F0] border border-[#003333]/20 rounded-none text-center">
                <p className="text-[#003333] font-medium">{successMessage}</p>
            </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4 w-full">
            <div className="flex flex-col sm:flex-row gap-3 w-full">
                <FormField control={control} name="first_name" render={({
        field
      }) => <FormItem className="flex-1">
                            <FormControl>
                                <Input placeholder="Your Name (Optional)" className="bg-[#FFF9F0] border-0 border-b border-[#003333] rounded-none text-[#003333] placeholder:text-[#003333]/60 focus-visible:ring-0 h-11" {...field} />
                            </FormControl>
                            <FormMessage className="text-red-600 text-xs" />
                        </FormItem>} />

                <FormField control={control} name="email" rules={{
        required: "Email address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem className="flex-[2]">
                            <FormControl>
                                <Input type="email" placeholder="Your Email Address" className="bg-[#FFF9F0] border-0 border-b border-[#003333] rounded-none text-[#003333] placeholder:text-[#003333]/60 focus-visible:ring-0 h-11" {...field} />
                            </FormControl>
                            <FormMessage className="text-red-600 text-xs" />
                        </FormItem>} />

                <Button type="submit" disabled={isSubmitting} className="bg-[#FF6B35] text-white hover:bg-[#FF6B35]/90 h-11 px-8 font-bold rounded-none uppercase shadow-none">
                    {isSubmitting ? <>
                            <Loader className="animate-spin mr-2 size-4" />
                            PLEASE WAIT...
                        </> : 'SUBSCRIBE'}
                </Button>
            </div>

            <FormField control={control} name="agree" rules={{
      required: "You must agree to receive the newsletter"
    }} render={({
      field
    }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0 pt-1">
                        <FormControl>
                            <input type="checkbox" className="mt-1 h-4 w-4 shrink-0 rounded-none border-[#003333] bg-[#FFF9F0] text-[#003333] focus:ring-[#003333] focus:ring-offset-0 cursor-pointer" checked={field.value} onChange={field.onChange} onBlur={field.onBlur} ref={field.ref} />
                        </FormControl>
                        <div className="space-y-1 leading-none">
                            <FormLabel className="text-[#003333]/80 text-sm font-normal cursor-pointer">
                                I agree to receive the Baby Names newsletter and updates.
                            </FormLabel>
                            <FormMessage className="text-red-600 text-xs" />
                        </div>
                    </FormItem>} />

            {submitError && <div className="p-3 bg-red-500/10 border border-red-500/50 rounded-none">
                    <p className="text-red-600 text-sm">{submitError}</p>
                </div>}
        </Form>;
}
export default function PackagingInsightsNewsletter() {
  return <section id="newsletter-signup" className="bg-[#A7F3D0] py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 lg:gap-12">
                    
                    <div className="lg:w-1/3 shrink-0">
                        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#003333] mb-3">
                            Stay Inspired
                        </h2>
                        <p className="font-sans text-[#003333]/80 text-base">
                            Join our community of parents and receive the latest baby naming trends, cultural insights, and special name meanings directly in your inbox.
                        </p>
                    </div>

                    <div className="lg:w-2/3 w-full">
                        <FormProvider formKey="newsletter_signup_namestartingwiththelettera" formId="newsletter_signup_namestartingwiththelettera" sectionName="newsletter-signup" defaultValues={{
            first_name: "",
            email: "",
            agree: false
          }} submitText="SUBSCRIBE" successMessage="Thank you! You've successfully joined our community." errorMessage="Sorry, there was an error. Please try again.">
                            <NewsletterForm />
                        </FormProvider>
                    </div>

                </div>
            </div>
        </section>;
}